import $http from '../../axios-instance';
import Swal from 'sweetalert2';

export async function getUnidadesDeMedida({state, commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_general/control-por-codigo/mostrar/capall`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setUnidades', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br />' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}
